Results = window.Results = (function () {
    const selectors = {
        betPlace: '#bet-place',
        searchInput: '#search-input',
        dateStart: '#results-datetime-filter-datepicker-from',
        dateEnd: '#results-datetime-filter-datepicker-to',
        dateStartVal: '#results-datetime-filter-value-from',
        dateEndVal: '#results-datetime-filter-value-to',
        datetimeFilterOverlay: '#results-datetime-filter-overlay',
        setPeriod: '#results-datetime-filter-confirm-button',
        setToday: '#results-set_today',
        typeFilter: '#results-type',
        vmSelectAll: '#sports-filter__select-all',
        vmSportsFilterItem: '.j-sports-filter-item',
        vmSportsFilterSelectButton: '.j-sports-filter-item-select-button',
        vmSportsFilterLinkButton: '.j-sports-filter-item-link-button',
        vmSportsFilterItemsContainer: '#vm-sports-filter-items',
        emptyBetplace: '#empty_betplace',
        sportsBlock: '.results-block',
        eventExpandButton: '[res-event-expand-button]',
        event: '[res-event]',
        goto: '.icon-results-goto',
        pageScrollbarContainer: '#m-page-content-scrollbar-scrollarea',
        tbExpandSport: '.js-expand-table',
        tbLeague: '.js-expand-league',
        collapseAllNodes: '#cm-collapse_all_nodes',
        datetimeFilter: '#results-datetime-filter',
        datetimeFilterDropdownWrapper: '#results-datetime-filter-dropdown-wrapper',
        openDatetimeFilterButton: '#open-datetime-filter-button',
        timeFilter: '[results-time-filter]'
    };
    function getHours() {
        return new Date($(selectors.datetimeFilterDropdownWrapper).data('initial-today')).getHours() * 60 * 60 * 1000;
    }

    function getMinutes() {
        return new Date($(selectors.datetimeFilterDropdownWrapper).data('initial-today')).getMinutes() * 60 * 1000;
    }

    function getFromTimestamp() {
        var local = $(selectors.dateStart).datepicker('getDate').getTime() + getHours() + getMinutes();
        var timezoneTimestamp = local - new Date(local).getTimezoneOffset() * 60 * 1000;
        return timezoneTimestamp;
    }

    function getToTimestamp() {
        var local = $(selectors.dateEnd).datepicker('getDate').getTime() + getHours() + getMinutes();
        var timezoneTimestamp = local - new Date(local).getTimezoneOffset() * 60 * 1000;
        return timezoneTimestamp;
    }

    function getFromDateTimestamp() {
        var localDate = new Date($(selectors.dateStart).datepicker('getDate'));
        var timezoneDateTime = new Date(localDate.getTime() - localDate.getTimezoneOffset() * 60 * 1000);
        var timezoneDate = Date.UTC(timezoneDateTime.getUTCFullYear(), timezoneDateTime.getUTCMonth(), timezoneDateTime.getUTCDate());
        return timezoneDate;
    }

    function getToDateTimestamp() {
        var localDate = new Date($(selectors.dateEnd).datepicker('getDate'));
        var timezoneDateTime = new Date(localDate.getTime() - localDate.getTimezoneOffset() * 60 * 1000);
        var timezoneDate = Date.UTC(timezoneDateTime.getUTCFullYear(), timezoneDateTime.getUTCMonth(), timezoneDateTime.getUTCDate());
        return timezoneDate;
    }

    function init() {
        initDatepickers();
        bindUI();
        app.Search.init('results');
    }

    function bindUI() {
        $(document).on('click.openDatetimeFilterButton', selectors.openDatetimeFilterButton, function () {
            datepickerHelper.openFilter();
        });

        $(document).on('click.timeFilter', selectors.timeFilter, function () {
            var hours = $(this).attr('results-time-filter');
            var text = $(this).text();
            filterByTime(hours);
            $(selectors.dateStartVal).text(text);
            $(selectors.datetimeFilter).addClass('m-text');
            datepickerHelper.closeFilter();
        });

        $(document).on('click', selectors.setPeriod, function () {
            datepickerHelper.closeFilter();
        });

        $(document).on('click', selectors.datetimeFilterOverlay, function () {
            datepickerHelper.closeFilter();
            datepickerHelper.restorePrevVals();
            datepickerHelper.savePrevVals();
            datepickerHelper.restorePrevVals();
        });
    }

    function filterByTime(hours) {
        var intialToday = new Date($(selectors.datetimeFilterDropdownWrapper).data('initial-today'));
        var to = intialToday.getTime() - intialToday.getTimezoneOffset() * 60 * 1000 - 100;

        var from = to - 1000 * 60 * 60 * hours;

        datepickerHelper.setFrom(from);
        datepickerHelper.setTo(to);

        $(selectors.setPeriod).click();
    }

    var datepickerHelper = {
        overlay: $('<div/>', {
            'class': 'results-datetime-filter__overlay',
            'id': 'results-datetime-filter-overlay'
        }),
        setFrom: function (timestamp) {
            $(selectors.dateStart).attr('data-timestamp', timestamp);
            $(selectors.dateStart).datepicker('setDate', new Date(timestamp));
            $(selectors.dateStartVal).html($(selectors.dateStart).datepicker().val());
            datepickerHelper.updateDatepickersHeaders();
        },
        setTo: function (timestamp) {
            datepickerHelper.setDateEndMaxValue();
            $(selectors.dateEnd).attr('data-timestamp', timestamp);
            $(selectors.dateEnd).datepicker('setDate', new Date(timestamp));
            $(selectors.dateEndVal).html($(selectors.dateEnd).datepicker().val());
            datepickerHelper.updateDatepickersHeaders();
        },
        updateDatepickersHeaders: function () {
            setTimeout(function () {
                var monthNames = [Localization.getString('Datepicker.January1', 'января'), Localization.getString('Datepicker.February1', 'февраля'), Localization.getString('Datepicker.March1', 'марта'), Localization.getString('Datepicker.April1', 'апреля'), Localization.getString('Datepicker.May1', ''), Localization.getString('Datepicker.June1', 'мая'), Localization.getString('Datepicker.July1', 'июля'), Localization.getString('Datepicker.August1', 'августа'), Localization.getString('Datepicker.September1', 'сентября'), Localization.getString('Datepicker.October1', 'октября'), Localization.getString('Datepicker.November1', 'ноября'), Localization.getString('Datepicker.December1','декабря')];
                var fromText = $(selectors.dateStart).datepicker('getDate').getDate() + ' ' + monthNames[$(selectors.dateStart).datepicker('getDate').getMonth()];

                if ($('.page-navigation__link.m-active[data-type]').data('type').toLowerCase() !== 'live') {
                    fromText = window.Localization.getString('Scripts_Shared_Main.Results_16', 'с ') + fromText;
                }

                $('#results-datetime-filter-datepicker-from .ui-datepicker-month').html(fromText);
                $('#results-datetime-filter-datepicker-to .ui-datepicker-month').html(window.Localization.getString('Scripts_Shared_Main.Results_17', 'по ') + $(selectors.dateEnd).datepicker('getDate').getDate() + ' ' + monthNames[$(selectors.dateEnd).datepicker('getDate').getMonth()]);
            });
        },
        savePrevVals: function () {
            $(selectors.dateStartVal).attr('data-prev-timestamp', getFromTimestamp());
            $(selectors.dateEndVal).attr('data-prev-timestamp', getToTimestamp());
        },
        restorePrevVals: function () {
            datepickerHelper.setFrom(parseInt($(selectors.dateStartVal).attr('data-prev-timestamp')));
            datepickerHelper.setTo(parseInt($(selectors.dateEndVal).attr('data-prev-timestamp')));
        },
        openFilter: function () {
            $(selectors.datetimeFilter).addClass('m-expanded');
            document.body.style.overflow = 'hidden';
            document.body.style.top = `-${window.scrollY}px`;
            datepickerHelper.overlay.appendTo('body');
            datepickerHelper.savePrevVals();
        },
        closeFilter: function () {
            $(selectors.datetimeFilter).removeClass('m-expanded');
            document.body.style.overflow = '';
            document.body.style.top = '';
            datepickerHelper.overlay.remove();
        },
        setDateEndMaxValue: function () {
            var from = $(selectors.dateStart),
                to = $(selectors.dateEnd);

            var maxDateTimestamp = from.datepicker('getDate').getTime() + 1000 * 60 * 60 * 24 * 7,
                maxDate = maxDateTimestamp < new Date($(selectors.datetimeFilterDropdownWrapper).data('initial-today')).getTime() ? new Date(from.datepicker('getDate').getTime() + 1000 * 60 * 60 * 24 * 6) : new Date($(selectors.datetimeFilterDropdownWrapper).data('initial-today'));

            to.datepicker('option', 'minDate', from.datepicker('getDate'));
            to.datepicker('option', 'maxDate', maxDate);
        },
        selectRange: function (date) {
            if (!$(selectors.dateEnd).datepicker('getDate'))
                return false;

            dateTimestamp = date.getTime();
            var startTime = $(selectors.dateStart).datepicker('getDate').getTime();
            var endTime = $(selectors.dateEnd).datepicker('getDate').getTime();

            if (dateTimestamp === startTime && dateTimestamp === endTime) {
                return [true, 'm-highlight-start m-highlight-end'];
            } else if (dateTimestamp === startTime) {
                return [true, 'm-highlight-start'];
            } else if (dateTimestamp === endTime) {
                return [true, 'm-highlight-end'];
            } else if (dateTimestamp > startTime && dateTimestamp < endTime) {
                return [true, 'm-highlight-range'];
            } else {
                return [true, ''];
            }
        },
        isLive: function () {
            return $('.page-navigation__link.m-active[data-type]').data('type').toLowerCase() === 'live';
        }
    };

    function initDatepickers() {
        var from = $(selectors.dateStart).datepicker({
            dateFormat: 'dd.mm.yy',
            defaultDate: new Date($(selectors.dateStart).data('initial-datetime')),
            maxDate: new Date($(selectors.datetimeFilterDropdownWrapper).data('initial-today')),
            showOtherMonths: true,
            selectOtherMonths: true,
            onSelect: function (dateText, inst) {
                datepickerHelper.setDateEndMaxValue();
                to.datepicker('setDate', from.datepicker('getDate'));
                setActualValue();
                $(selectors.datetimeFilter).removeClass('m-text');
            },
            beforeShowDay: function (date) {
                return datepickerHelper.selectRange(date);
            }
        });

        var to = $(selectors.dateEnd).datepicker({
            dateFormat: 'dd.mm.yy',
            defaultDate: new Date($(selectors.dateEnd).data('initial-datetime')),
            maxDate: new Date($(selectors.datetimeFilterDropdownWrapper).data('initial-today')),
            showOtherMonths: true,
            selectOtherMonths: true,
            onSelect: function (dateText, inst) {
                setActualValue();
                $(selectors.datetimeFilter).removeClass('m-text');
            },
            beforeShowDay: function (date) {
                return datepickerHelper.selectRange(date);
            }
        });

        function setActualValue() {
            datepickerHelper.setFrom(getFromDateTimestamp());
            datepickerHelper.setTo(getToDateTimestamp());
        }

        var initialToDate = new Date($(selectors.dateEnd).data('initial-datetime'));
        var initialFromTimestamp = new Date($(selectors.dateStart).data('initial-datetime')).getTime();
        var initialToTimestamp = initialToDate.getTime();
        var today = new Date($(selectors.datetimeFilterDropdownWrapper).data('initial-today'));

        datepickerHelper.setFrom(getFromDateTimestamp());
        datepickerHelper.setTo(getToDateTimestamp());
        datepickerHelper.savePrevVals();
        datepickerHelper.restorePrevVals();

        function setInitInterval(intervalInHours) {
            var text = $(selectors.timeFilter).filter('[results-time-filter="' + intervalInHours + '"]').text();
            $(selectors.dateStartVal).text(text);
            $(selectors.datetimeFilter).addClass('m-text');
        }

        // если выбран временной интервал
        var intervalInHours = (initialToTimestamp - initialFromTimestamp) / 1000 / 60 / 60;
        if (intervalInHours !== 0 && [1, 3, 6, 12, 24].indexOf(intervalInHours) > -1) {
            if (initialToDate.getDate() === today.getDate() && initialToDate.getMonth() === today.getMonth() && initialToDate.getFullYear() === today.getFullYear()) {
                setInitInterval(intervalInHours);
            }
        }
    }

    function dispose() {
        $('#page-content').empty();
    }

    return {
        selectors: selectors,
        init: init,
        dispose: dispose
    }
}());